import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { CForm, Success, Error } from "./styles";
import { notification } from "../../framer/animation";

export const ContactForm = () => {
	const form = useRef();

	const [status, setStatus] = useState("");

	const sendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_lzf67i9",
				"template_mttyvj9",
				form.current,
				"user_LgCa2nEAzXRvsipGrzjzi"
			)
			.then(
				(result) => {
					setStatus("Success");
				},
				(error) => {
					setStatus("Fail");
				}
			);
		e.target.reset();
	};

	useEffect(() => {
		if (status === "Success" || "Fail") {
			setTimeout(() => {
				setStatus("");
			}, 5000);
		}
	}, [status]);

	return (
		<>
			<CForm ref={form} onSubmit={sendEmail}>
				{status === "Success" && (
					<Success
						variants={notification}
						initial='hidden'
						animate='show'
						className='success'
					>
						<p>Your message succesfully sent!</p>
					</Success>
				)}
				{status === "Fail" && (
					<Error
						variants={notification}
						initial='hidden'
						animate='show'
						className='error'
					>
						<p>Something went wrong. Try again, please.</p>
					</Error>
				)}
				<label>Your Name</label>
				<input type='text' name='name' required />
				<label>Your Email</label>
				<input type='email' name='email' required />
				<label>Subject</label>
				<input type='text' name='subject' required />
				<label>Your message</label>
				<textarea name='message' required />
				<button type='submit'>Send</button>
			</CForm>
		</>
	);
};
